import React, { useState, useEffect } from "react";

import VirtualGridComponent from "../react/components_proto/VirtualGridComponent/VirtualGridComponent";
import { StringWms } from "../../assets/ts/StringWms";
import * as GlobalService from "../react/global_services";
import * as GridConfig from "./parcel-shipments-grid-configuration";
import PropTypes from "prop-types";
import * as ParcelShipmentsServices from "./parcel-shipments.services";
import { AddEditColumnModel } from "../react/components/AddEditColumn/add-edit-columns.component";
import { ArrayWms } from "../../assets/ts/ArrayWms";
import { ConcurrencyManager } from "../../assets/vendor/concurrencyManager/concurrencyManager";
import { LoadingModel } from "../react/components/LoadingModel/LoadingModel";

import "./parcel-shipments.scss";
import _ from "lodash";
import axios from "axios";

interface gridFilterType {
    SearchTarget: string;
    IndexOptionsSearchBy: string;
    StartDate: string;
    EndDate: string;
    DeliveryStatus: string;
    IndexOptionsCustomerId: string;
    IndexOptionsFacilityId: string;
    Carrier: string;
    ShipService: string;
}

interface Props {
    gridInlineFilter: any;
    wmsSelector: string;
    windowId: string;
    gridId: string;
    sharedFilterObject: gridFilterType;
    hideFilterToggle: (flag: boolean) => void;
    setTrackingInfoData: (data: any) => void;
}

declare var window: any;
const { $ } = window;

let localKendoGrid = null;

const ParcelShipmentsGrid: React.FC<Props> = (incomingProps: Props) => {
    const {
        wmsSelector = "",
        windowId = "",
        sharedFilterObject = {
            SearchTarget: "",
            IndexOptionsSearchBy: "0",
            StartDate: "",
            EndDate: "",
            DeliveryStatus: "",
            IndexOptionsCustomerId: "0",
            IndexOptionsFacilityId: "0",
            Carrier: "",
            ShipService: "",
        },
    } = incomingProps;
    const props = {
        ...incomingProps,
        wmsSelector,
        windowId,
        sharedFilterObject,
    };

    const parcelShipmentsGridHeaders = StringWms.convertSringToOption(window.translate("Shipments_GridHeaders"));
    const defaultColumns = GridConfig.applyParcelShipmentsDeliveryStatusFilterUi(
        GridConfig.getParcelShipmentsColumns(parcelShipmentsGridHeaders).columns
    );
    const allColumnList = GridConfig.applyParcelShipmentsDeliveryStatusFilterUi(
        GridConfig.getParcelShipmentsAllColumnList(parcelShipmentsGridHeaders)
    );
    const [schema] = useState(GridConfig.getParcelShipmentsSchema());
    const gridDomSelector = props.windowId ? "." + props.windowId + " #" + props.gridId : "#" + props.gridId;
    const [gridConfig, setGridConfig] = useState("");
    let filterCountAxiosSource = null;
    let firstFiftyAxiosSource = null;
    let axiosSource = null;
    let isApiCanceled = false;

    const [filterText, setFilterText] = useState("");
    const [fullFilterText, setFullFilterText] = useState("");
    const [recordsCount, setRecordsCount] = useState(0);
    const [gridData, setGridData] = useState<any[]>([]);
    const [isOpenColumnModal, setIsOpenColumnModal] = useState(false);
    const [isAllDataLoad, setIsAllDataLoad] = useState(false);
    const [isFilterRowCountLoading, setIsFilterRowCountLoading] = useState(false);
    const [showLoadingError, setShowLoadingError] = useState(false);
    const [isNewColumnAdded, setIsNewColumnAdded] = useState(false);
    const [isGridDataLoading, setIsGridDataLoading] = useState(false);
    const [gridPageSize] = useState(GlobalService.constants.virtualOrderGridDataLimit);
    const [overlayScreenShow, setOverlayScreenShow] = useState(false);
    const [totalRequest, setTotalRequest] = useState(0);
    const [lastRefreshGridTime, setLastRefreshGridTime] = useState("");
    const [isTrackingInfoLoading, setIsTrackingInfoLoading] = useState(false);

    useEffect(() => {
        setFilterAppliedText(props.gridInlineFilter);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props.gridInlineFilter]);

    const updateDeliveryStatusFromTrackingInfo = (trackingInfoResponse: any) => {
        const trackingInfo =
            trackingInfoResponse?.TrackingInfo || trackingInfoResponse?.trackingInfo || trackingInfoResponse;
        const packageId = trackingInfo?.packageId ?? trackingInfo?.PackageId;
        const deliveryStatus = trackingInfo?.deliveryStatus ?? trackingInfo?.DeliveryStatus;

        if (packageId === undefined || packageId === null || !deliveryStatus) {
            return null;
        }

        const packageIdToMatch = String(packageId);

        setGridData((currentGridData) =>
            currentGridData.map((row: any) =>
                String(row.PackageId) === packageIdToMatch ? { ...row, DeliveryStatus: deliveryStatus } : row
            )
        );

        const grid = $(gridDomSelector).data("kendoGrid");
        if (grid?.dataSource) {
            grid.dataSource.data().forEach((row: any) => {
                if (String(row.PackageId) === packageIdToMatch) {
                    if (typeof row.set === "function") {
                        row.set("DeliveryStatus", deliveryStatus);
                    } else {
                        row.DeliveryStatus = deliveryStatus;
                    }
                }
            });
            grid.refresh();
        }

        return {
            packageId,
            deliveryStatus,
        };
    };

    const onselectGridRow = (KendoGrid: any, eventType: string) => {
        localKendoGrid = KendoGrid;
        let grid = $(gridDomSelector).data("kendoGrid");
        var data = grid.dataItem(grid.select());
        if (data) {
            let selectedRows = grid.select();

            // If multiple rows are selected, we need to implement single row selection
            if (selectedRows && selectedRows.length > 1) {
                // Get the clicked row (the one that should remain selected)
                let clickedRow = selectedRows[selectedRows.length - 1];
                let clickedDataItem = grid.dataItem(clickedRow);

                if (clickedRow && clickedDataItem) {
                    grid.clearSelection();
                    grid.select(clickedRow);

                    KendoGrid.clearSelections(() => {
                        // Add only the clicked row back to the selection
                        KendoGrid.addSelections(clickedDataItem.RowNumber, clickedDataItem);
                        KendoGrid.repaintSelections();
                    });
                    data = clickedDataItem;
                }

                if (data?.PackageUrl) {
                    setIsTrackingInfoLoading(true);
                    ParcelShipmentsServices.getTrackPackageInfo(data.PackageUrl)
                        .then((response: any) => {
                            if (response) {
                                data.TrackingInfo = response;
                                const trackingStatus = updateDeliveryStatusFromTrackingInfo(response);
                                if (trackingStatus && String(data.PackageId) === String(trackingStatus.packageId)) {
                                    data.DeliveryStatus = trackingStatus.deliveryStatus;
                                }
                            }

                            props.hideFilterToggle(true);
                            props.setTrackingInfoData(data);
                            setIsTrackingInfoLoading(false);
                        })
                        .catch((error: any) => {
                            console.error("Error fetching tracking info:", error);
                            setIsTrackingInfoLoading(false);
                            props.hideFilterToggle(true);
                            props.setTrackingInfoData(data);
                        });
                } else {
                    props.hideFilterToggle(true);
                    props.setTrackingInfoData(data);
                }
            }
        } else {
            props.setTrackingInfoData(data);
            if (eventType === "contextMenuClick" || eventType === "rowClick") {
                props.hideFilterToggle(false);
            }
        }
    };
    const clickEventOfContextMenu = (obj: any, e: any) => {
        console.log("obj.wmsid", obj.wmsid);
    };

    const onGridDataBound = (e, kendoGrid) => {
        localKendoGrid = kendoGrid;
    };
    // on grid filter selection
    const onGridFilterApplied = () => {
        var grid = $(gridDomSelector).data("kendoGrid");
        var dataSource = grid.dataSource;
        setTimeout(() => {
            let filter = dataSource.filter();
            var sortArray = grid.dataSource.sort() ? grid.dataSource.sort() : [];
            var finalSubmission = localKendoGrid.prepareGridOptionsForStorage(grid.columns, sortArray, filter);
            ParcelShipmentsServices.setParcelShipmentsGridOptionInMetaData(finalSubmission);
            setFilterAppliedText(filter);
        }, 50);
    };
    const setFilterAppliedText = (filterObj) => {
        if (!filterObj) {
            setFilterText("");
            setFullFilterText("");
            return;
        }
        var filterConditionTitle = {
            lte: "Is Less Than Or Equal To",
            eq: "Is Equal To",
            lt: "Is Less Than",
            neq: "Is Not Equal To",
            gte: "Is Greater Than Or Equal To",
            gt: "Is Greater Than",
            startswith: "Starts With",
            endswith: "Ends With",
            contains: "Contains",
            doesnotcontain: "Does Not Contain",
            isnull: "Is Null",
            isnotnull: "Is Not Null",
            isempty: "Is Empty",
            isnotempty: "Is Not Empty",
            isnullorempty: "Has No Value",
            isnotnullorempty: "Has Value",
        };

        var filterText = "";
        var fullFilterText = "";
        var filterList = filterObj.filters;

        filterList.map((item) => {
            var title = allColumnList.find((x) => x.field === item.field).title;
            const filterValue = item.value === "notYetInsystem" ? "Label Created" : item.value;
            filterText += title + " : " + filterValue + ",";
            fullFilterText += title + " " + filterConditionTitle[item.operator] + " : " + filterValue + "<br>";
            return item;
        });
        filterText = filterText.slice(0, -1);
        setFilterText(filterText);
        setFullFilterText(fullFilterText);
    };
    // on grid column sort save changes in meta data object
    const onSort = (event) => {
        var grid = $(gridDomSelector).data("kendoGrid");
        var sortArray = grid.dataSource.sort() ? grid.dataSource.sort() : [];
        GlobalService.sortDataset(sortArray, event.sort);
        var gridColumn = grid.getOptions().columns;
        var finalSubmission = localKendoGrid.prepareGridOptionsForStorage(
            gridColumn,
            sortArray,
            grid.dataSource.filter()
        );
        ParcelShipmentsServices.setParcelShipmentsGridOptionInMetaData(finalSubmission);
    };
    // on grid column reorder save changes in meta data object
    const onColumnReorder = (event) => {
        var grid = $(gridDomSelector).data("kendoGrid");
        var sortArray = grid.dataSource.sort() ? grid.dataSource.sort() : [];
        let gridColumn = grid.getOptions().columns;
        let switchedArray = ArrayWms.switchIndexByField(gridColumn, event.newIndex, event.oldIndex);
        let finalSubmission = localKendoGrid.prepareGridOptionsForStorage(
            switchedArray,
            sortArray,
            grid.dataSource.filter()
        );
        ParcelShipmentsServices.setParcelShipmentsGridOptionInMetaData(finalSubmission);
    };

    // on grid column resize save changes in meta data object
    const onColumnResize = () => {
        var grid = $(gridDomSelector).data("kendoGrid");
        var sortArray = grid.dataSource.sort() ? grid.dataSource.sort() : [];
        let finalSubmission = localKendoGrid.prepareGridOptionsForStorage(
            grid.columns,
            sortArray,
            grid.dataSource.filter()
        );
        ParcelShipmentsServices.setParcelShipmentsGridOptionInMetaData(finalSubmission);
    };

    // on click grid clear sort menu
    const onClickClearSorts = () => {
        var grid = $(gridDomSelector).data("kendoGrid");
        var finalSubmission = localKendoGrid.prepareGridOptionsForStorage(grid.columns, [], grid.dataSource.filter());
        ParcelShipmentsServices.setParcelShipmentsGridOptionInMetaData(finalSubmission);
    };

    // on click grid reset default grid layout menu
    const onClickResetGrid = () => {
        var finalSubmission = {
            optionsData: {},
        };
        ParcelShipmentsServices.setParcelShipmentsGridOptionInMetaData(finalSubmission);
    };

    const eventClickExportGrid = () => {
        $(gridDomSelector).getKendoGrid().saveAsExcel();
    };

    const listGrid_dataBind = (data) => {
        _.map(data, function (value) {
            value.TotalCharges = 0;
            _.map(value.Billing, function (subValue) {
                value.TotalCharges += subValue.TotalCharges;
                return value;
            });
            return data;
        });

        // Sort data by ShipDate in descending order (latest first)
        const sortedData = _.orderBy(data, ["ShipDate"], ["desc"]);

        setIsGridDataLoading(false);
        setLastRefreshGridTime(getCurrentTimeFormatted());
        setGridData(sortedData);
    };
    // on new filter data clear selection of grid
    const clearSelectionOfGrid = () => {
        if (localKendoGrid != null) {
            localKendoGrid.clearSelections(() => {
                localKendoGrid.repaintSelections();
            });
        }
    };

    const refreshGrid = () => {
        clearSelectionOfGrid();
        callForGetTotalCount();
    };

    const onToggleColumnModal = (isOpen) => () => {
        setIsOpenColumnModal(isOpen);
    };

    const saveMetaData = () => {
        var grid = $(gridDomSelector).data("kendoGrid");
        var sort = grid.dataSource.sort() ? grid.dataSource.sort() : [];
        let finalSubmission = localKendoGrid.prepareGridOptionsForStorage(grid.columns, sort, grid.dataSource.filter());
        ParcelShipmentsServices.setParcelShipmentsGridOptionInMetaData(finalSubmission);
    };

    useEffect(() => {
        const rawMeta = ParcelShipmentsServices.getParcelShipmentsGridOptionInMetaData();
        setGridConfig(
            GridConfig.buildParcelShipmentsMetaGridConfigForVirtualGrid(rawMeta, allColumnList, defaultColumns)
        );
        if (props.sharedFilterObject) {
            callForGetTotalCount();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props.sharedFilterObject]);

    useEffect(() => {
        if (recordsCount > 0) {
            callForGetNewData();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [recordsCount]);

    // Cancel axios call if new filter applied
    const cancelLoadAllData = () => {
        if (firstFiftyAxiosSource) {
            firstFiftyAxiosSource.cancel();
            firstFiftyAxiosSource = null;
        }
        if (axiosSource) {
            axiosSource.cancel();
            axiosSource = null;
        }
        isApiCanceled = true;
        setIsGridDataLoading(false);
        setOverlayScreenShow(false);
        setGridData([]);
        setIsAllDataLoad(false);
    };
    const callForGetTotalCount = (clearData = true, clearGridSelection = false) => {
        setRecordsCount(0);
        setIsFilterRowCountLoading(true);
        setShowLoadingError(false);

        if (clearGridSelection) {
            // setSelectedRowCount(0);
            setIsAllDataLoad(false);
        }

        var param_filterObj = Object.assign({}, props.sharedFilterObject);
        param_filterObj.StartDate = StringWms.convertFilterStringToISODate(
            param_filterObj.StartDate,
            "",
            false,
            true
        ).isoStringUTC;
        param_filterObj.EndDate = StringWms.convertFilterStringToISODate(
            param_filterObj.EndDate,
            "23:59:59",
            false,
            true
        ).isoStringUTC;
        if (filterCountAxiosSource) {
            filterCountAxiosSource.cancel();
            filterCountAxiosSource = null;
        }
        // on filter update cancel axiosSource call if any running
        cancelLoadAllData();
        filterCountAxiosSource = axios.CancelToken.source();
        // eslint-disable-next-line sonarjs/no-duplicate-string
        if (param_filterObj.DeliveryStatus && param_filterObj.DeliveryStatus.includes("labelCreated")) {
            // eslint-disable-next-line sonarjs/no-duplicate-string
            param_filterObj.DeliveryStatus = param_filterObj.DeliveryStatus.concat(",notYetInSystem");
        }

        // Call for FilterRowCount.
        ParcelShipmentsServices.setGridFilter(param_filterObj, filterCountAxiosSource.token)
            .then((response: any) => {
                setRecordsCount(response.data);
                if (clearData) {
                    setGridData([]);
                }
                filterCountAxiosSource = null;
            })
            .finally(() => {
                setIsFilterRowCountLoading(false);
            });
    };
    const resetGridAllMessage = () => {
        if (isAllDataLoad) {
            setIsNewColumnAdded(true);
        }
    };

    const callForGetNewData = () => {
        if (recordsCount > 0 && recordsCount <= gridPageSize) {
            setIsGridDataLoading(true);
            loadAllRecords(false);
            setIsFilterRowCountLoading(false);
        } else {
            resetGridAllMessage();
        }
    };
    const sequence = (n) => {
        let seq = [];
        for (let i = 0; i < n; i++) {
            seq.push(i);
        }
        return seq;
    };
    const getAllResponseData = (data) => {
        if (!isApiCanceled) {
            let allData = [];
            data.forEach((obj) => {
                allData = [...obj.Data, ...allData];
            });
            // Sort all data by ShipDate in descending order (latest first)
            const sortedAllData = _.orderBy(allData, ["ShipDate"], ["desc"]);
            listGrid_dataBind(sortedAllData);
            setOverlayScreenShow(false);
            setIsGridDataLoading(false);
            setIsAllDataLoad(true);
            setIsNewColumnAdded(false);
        } else {
            setIsGridDataLoading(false);
        }
    };
    const getEnableColumns = () => {
        var defaultParam = [
            "PackageUrl",
            "OrderId",
            "PackageId",
            "Carrier",
            "TrackingNumber",
            "TrackingUrl",
            "DeliveryDate",
            "ShipDate",
            "TransactionId",
        ];
        let columnList = [];

        let grid = $(gridDomSelector).data("kendoGrid");
        // if grid already defined than we get columns from grid
        if (typeof grid != "undefined") {
            columnList = grid.columns;
        } else {
            // else get column list from metadataObject or default columns
            columnList = GridConfig.getParcelShipmentsColumns(parcelShipmentsGridHeaders).columns;
        }

        var enableColumns = columnList.map((el) => el.field);
        // merge defaultParam and enableColumns without dublicate value
        return _.uniq(defaultParam.concat(enableColumns));
    };
    const loadAllRecords = (isLoaderPopupShow) => {
        isApiCanceled = false;
        if (isLoaderPopupShow) {
            setIsGridDataLoading(true);
            setGridData([]);
        }

        var param_filterObj = Object.assign({}, props.sharedFilterObject);
        param_filterObj.StartDate = StringWms.convertFilterStringToISODate(
            param_filterObj.StartDate,
            "",
            false,
            true
        ).isoStringUTC;
        param_filterObj.EndDate = StringWms.convertFilterStringToISODate(
            param_filterObj.EndDate,
            "23:59:59",
            false,
            true
        ).isoStringUTC;
        // eslint-disable-next-line sonarjs/no-duplicate-string
        if (param_filterObj.DeliveryStatus && param_filterObj.DeliveryStatus.includes("labelCreated")) {
            param_filterObj.DeliveryStatus = param_filterObj.DeliveryStatus.concat(",notYetInSystem");
        }
        axiosSource = axios.CancelToken.source();
        let api = axios.create({
            baseURL: "/WebUI/Shipping/SmartParcel",
            headers: { "Access-Control-Allow-Origin": "*" },
            cancelToken: axiosSource.token,
        });
        const MAX_CONCURRENT_REQUESTS = 3;
        let totalRequest = Math.ceil(recordsCount / gridPageSize);
        setTotalRequest(totalRequest);
        var manager = ConcurrencyManager(api, MAX_CONCURRENT_REQUESTS, GlobalService);

        Promise.all(
            sequence(totalRequest).map((i) =>
                api.put("/SmartParcelTrackingData?sorts=[]&filters=[]&pgnum=" + (i + 1) + "&pgsiz=" + gridPageSize, {
                    columns: getEnableColumns(),
                    searchInfo: param_filterObj,
                })
            )
        )
            .then((responses) => {
                let inventoryData = responses.map((r) => r.data);
                getAllResponseData(inventoryData);
            })
            .catch((error) => {
                console.log("Promise.all catch", error);
                setShowLoadingError(true);
                cancelLoadAllData();
            })
            .then(() => {
                if (manager) {
                    manager.detach();
                }
            });
    };

    const onClickLoadAllRecords = () => {
        var param_filterObj = Object.assign({}, props.sharedFilterObject);
        param_filterObj.StartDate = param_filterObj.StartDate
            ? StringWms.convertFilterStringToISODate(param_filterObj.StartDate, "", false, true).isoStringUTC
            : null;
        param_filterObj.EndDate = param_filterObj.EndDate
            ? StringWms.convertFilterStringToISODate(param_filterObj.EndDate, "23:59:59", false, true).isoStringUTC
            : null;
        setOverlayScreenShow(true);

        if (param_filterObj.DeliveryStatus && param_filterObj.DeliveryStatus.includes("labelCreated")) {
            param_filterObj.DeliveryStatus = param_filterObj.DeliveryStatus.concat(",notYetInSystem");
        }
        if (firstFiftyAxiosSource) {
            firstFiftyAxiosSource.cancel();
            firstFiftyAxiosSource = null;
        }
        firstFiftyAxiosSource = axios.CancelToken.source();
        axios
            .put(
                "/WebUI/Shipping/SmartParcel/SmartParcelTrackingData?sorts=[]&filters=[]&pgnum=1&pgsiz=50",
                {
                    columns: getEnableColumns(),
                    searchInfo: param_filterObj,
                },
                { cancelToken: firstFiftyAxiosSource.token }
            )
            .then((response) => {
                firstFiftyAxiosSource = "";
                // Sort the first 50 records by ShipDate in descending order (latest first)
                const sortedFirstFifty = _.orderBy(response.data.Data, ["ShipDate"], ["desc"]);
                setGridData(sortedFirstFifty);
                loadAllRecords(false);
            });
    };
    const getCurrentTimeFormatted = () => {
        return window.moment().format("MMM DD YYYY, hh:mm:ss A");
    };

    return (
        <div className={`parcel-shipments-grid new-layout-grid-wrapper`}>
            <div className="wms-search-grid-data">
                <VirtualGridComponent
                    selectable="row"
                    virtualGridDataLimit={gridPageSize}
                    isNewColumnAdded={isNewColumnAdded}
                    isPreventGridRightClick={true}
                    callForGetNewData={callForGetNewData}
                    isAllDataLoad={isAllDataLoad}
                    loadAllRecords={onClickLoadAllRecords}
                    loading={isFilterRowCountLoading || isGridDataLoading}
                    loadAllMessageFirst={window.translate("Label_Grid_Filter_Message")}
                    loadAllMessageSecond={window.translate("Label_Grid_Filter_Message_2")}
                    showLoadingError={showLoadingError}
                    shawCheckbox={false}
                    id={props.gridId}
                    showSortColumns={true}
                    showGridSummary={true}
                    showGridResult={true}
                    showContentBetweenGridAndOptions={true}
                    contentLabel={window.translate("Label_Last_Update")}
                    contentValue={lastRefreshGridTime}
                    gridName={props.gridId}
                    windowId={props.windowId}
                    wmsSelector={props.wmsSelector + props.gridId}
                    gridKeySelection={"RowNumber"}
                    virtual={true}
                    totalResult={recordsCount}
                    staticGridData={gridData}
                    exportable={true}
                    isExportSelectedData={true}
                    emptyRecoredText={window.translate("Window_Title_Label_Empty_Records")}
                    exportExcelObj={{
                        fileName:
                            "ParcelShipmentsExport-" +
                            kendo.toString(kendo.parseDate(new Date().toString()), "yyyyMMddhhmmss") +
                            ".xlsx",
                        allPages: true,
                        filterable: true,
                    }}
                    csvExportFileName={"ParcelShipmentsExport"}
                    eventClickExportGrid={eventClickExportGrid}
                    allColumns={allColumnList}
                    defaultColumns={defaultColumns}
                    schema={schema}
                    onSelection={onselectGridRow}
                    clickEventOfContextMenu={clickEventOfContextMenu}
                    metaDataFieldsName={"ParcelShipments"}
                    onGridFilterApplied={onGridFilterApplied}
                    filterText={filterText}
                    fullFilterText={fullFilterText}
                    onDataBound={onGridDataBound}
                    onSort={onSort}
                    onColumnReorder={onColumnReorder}
                    onColumnResize={onColumnResize}
                    onClickClearSorts={onClickClearSorts}
                    onClickResetGrid={onClickResetGrid}
                    metaGridConfig={gridConfig}
                    eventClickColumns={onToggleColumnModal(true)}
                    menu={[
                        {
                            name: "",
                            wmsSelector: props.wmsSelector + "RefreshGrid",
                            value: [],
                            clickFunc: refreshGrid,
                            disabled: false,
                            icon: "fa-sync-alt",
                            color: "blue",
                            isContextMenu: false,
                            isButtonMenu: true,
                            parentClassName: "parcel-shipments-refresh-btn",
                        },
                    ]}
                />
            </div>
            {isOpenColumnModal && (
                <AddEditColumnModel
                    id={"addEditColumnEventNotification"}
                    height={700}
                    windowId={props.windowId}
                    onCloseColumnModel={onToggleColumnModal(false)}
                    isOpenColumnModel={isOpenColumnModal}
                    allSortColumnList={allColumnList}
                    gridId={props.gridId}
                    updateGridData={callForGetNewData}
                    saveChangesInMetaData={saveMetaData}
                    isShawRowNumberColumnInList={true}
                />
            )}
            {overlayScreenShow && (
                <LoadingModel
                    sharedOpenLoadingmodel={overlayScreenShow}
                    onCancelLoadAllData={cancelLoadAllData}
                    sharedTotalRequest={totalRequest}
                />
            )}
            {isTrackingInfoLoading && (
                <div className="tracking-info-loader">
                    <div className="loader-spinner"></div>
                    <div className="loader-text">Loading...</div>
                </div>
            )}
        </div>
    );
};
ParcelShipmentsGrid.propTypes = {
    wmsSelector: PropTypes.string.isRequired,
    windowId: PropTypes.string.isRequired,
    sharedFilterObject: PropTypes.any.isRequired,
};

export default React.memo(ParcelShipmentsGrid);
